import React, { Fragment, useState } from 'react';
import RecordsTable from './recordsTable';
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';

const userHeaders = ["Message", "Answers", "Targets", "Created At"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['message'] = obj.message;
    trimmedObj['answers'] = obj.answers;
    trimmedObj['targets'] = obj.targets;
    trimmedObj['createdAt'] = formatDate(new Date(obj.createdAt));
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Message = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`message?page=${page}${searchParam}`, reload);

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={() => toggleReload(r => !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />
      <PaginationBar page={page} totalCount={totalCount} setPage={setPage} />
    </Fragment>
  );
}
export default Message;